import { render } from "./DermatologyPage.vue?vue&type=template&id=9a84fcd6"
import script from "./DermatologyPage.vue?vue&type=script&lang=js"
export * from "./DermatologyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__